__turbopack_context__.v({
  "className": "inter_9c349a12-module__C1e0mG__className",
  "variable": "inter_9c349a12-module__C1e0mG__variable",
});
